import { r as registerInstance, h, H as Host } from './index-64cb465e.js';
import { g as getClassnames } from './misc-c573a6e7.js';
import { g as getIsValidButtonType } from './validations-a838eb3f.js';
import { b as buttonTypes } from './button-types-39a4787b.js';

const circleButtonCss = ".hrb-circle-button{--hrb-buttonBackground--color:var(--bds-background-primary);--hrb-buttonBorder--color:transparent;--hrb-buttonFont--color:var(--bds-icon-neutral);--hrb-buttonWidth:48px;--hrb-buttonHeight:48px;-ms-flex-align:center;align-items:center;background:var(--hrb-buttonBackground--color);border:2px solid var(--hrb-buttonBorder--color);border-radius:9999px;color:var(--hrb-buttonFont--color);display:-ms-flexbox;display:flex;height:var(--hrb-buttonWidth);-ms-flex-pack:center;justify-content:center;padding:0;-webkit-transition:background-color all 0.2s cubic-bezier(0.33, 0.66, 0.66, 1);transition:background-color all 0.2s cubic-bezier(0.33, 0.66, 0.66, 1);width:var(--hrb-buttonHeight)}.hrb-circle-button:hover{--hrb-buttonBackground--color:var(--bds-background-tertiary);--hrb-buttonFont--color:#262626;cursor:pointer}.hrb-circle-button:focus-visible{outline:2px solid var(--focus-color, #0095FF);outline-offset:2px}.hrb-circle-button.hrb-circle-button--outline{--hrb-buttonBorder--color:#262626}.hrb-circle-button.hrb-circle-button--outline:hover{--hrb-buttonBorder--color:var(--bds-background-tertiary)}.hrb-circle-button.hrb-circle-button--outline-white{--hrb-buttonBackground--color:transparent;--hrb-buttonBorder--color:#FFFFFF;--hrb-buttonFont--color:#FFFFFF}.hrb-circle-button.hrb-circle-button--outline-white:hover{--hrb-buttonBorder--color:var(--bds-background-tertiary)}.hrb-circle-button.hrb-circle-button--xsmall{--hrb-buttonWidth:32px;--hrb-buttonHeight:32px}.hrb-circle-button.hrb-circle-button--small{--hrb-buttonWidth:48px;--hrb-buttonHeight:48px}.hrb-circle-button.hrb-circle-button--medium{--hrb-buttonWidth:60px;--hrb-buttonHeight:60px}.hrb-circle-button.hrb-circle-button--large{--hrb-buttonWidth:80px;--hrb-buttonHeight:80px}.hrb-circle-button:disabled{--hrb-buttonBackground--color:var(--bds-state-disabled-100);--hrb-buttonBorder--color:transparent;--hrb-buttonFont--color:var(--bds-icon-neutral);cursor:default;pointer-events:none}.hrb-circle-button:active:not([disabled]){-webkit-transform:scale(0.97);transform:scale(0.97)}.hrb-circle-button .hrb-icon{--icon-size:20px}";
const HrbCircleButtonStyle0 = circleButtonCss;

const Constants = {
    baseClassname: 'hrb-circle-button',
};
const CircleButton = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.getProps = () => {
            const { pAriaControls, pAriaExpaned, pAriaLabel, pAriaLabelledby, pAriaRole, pTabIndex, as, disabled, href, rel, target, type, } = this;
            const isAnchor = as === buttonTypes.anchor;
            const isButton = as === buttonTypes.button;
            const sharedProps = {
                'aria-label': pAriaLabel,
                'aria-labelledby': pAriaLabelledby,
                'aria-role': pAriaRole,
                'aria-disabled': disabled,
                'aria-controls': pAriaControls,
                'aria-expanded': pAriaExpaned,
                tabindex: pTabIndex,
            };
            if (isAnchor) {
                return Object.assign(Object.assign({}, sharedProps), { href,
                    rel,
                    target });
            }
            if (isButton) {
                return Object.assign(Object.assign({}, sharedProps), { type,
                    disabled });
            }
            return Object.assign({}, sharedProps);
        };
        this.pAriaLabel = undefined;
        this.pAriaLabelledby = undefined;
        this.pAriaRole = undefined;
        this.pAriaExpaned = undefined;
        this.pAriaControls = undefined;
        this.pTabIndex = undefined;
        this.as = 'button';
        this.target = undefined;
        this.rel = undefined;
        this.href = undefined;
        this.disabled = false;
        this.type = undefined;
        this.size = 'small';
        this.theme = 'default';
        this.transparent = false;
        this.autoIdentifier = undefined;
    }
    componentWillLoad() {
        this.validateLinkType();
    }
    validateLinkType() {
        const isValidLinkType = getIsValidButtonType(this.as);
        if (!isValidLinkType) {
            this.throwConsoleError(this.as, 'type');
        }
    }
    throwConsoleError(val, prop) {
        // eslint-disable-next-line no-console
        console.error(`<hrb-circle-button /> : "${val}" is not a valid circle-button ${prop}`);
    }
    render() {
        const props = this.getProps();
        const { autoIdentifier, disabled, size, theme } = this;
        const { baseClassname } = Constants;
        const classes = getClassnames([
            `${baseClassname}`,
            disabled && `${baseClassname}--disabled`,
            `${baseClassname}--${theme}`,
            `${baseClassname}--${size}`,
        ]);
        let autoId = autoIdentifier;
        if (!autoId) {
            CircleButton.counter += 1;
            autoId = `HrbCircleButton${CircleButton.counter}`;
        }
        return (h(Host, { key: '7822f6bfe0fdccac3f5260d7409c2c2b6771ab50' }, h(this.as, Object.assign({ key: '3b1bf991a537592d8b978a07299a5954320a9614', class: classes }, props, { "data-automation-action": autoId }), h("slot", { key: '290e5cf4bcf5919f8ad02fb36536e3f159d45c88' }))));
    }
};
/** Counter for incrementing autoidentifer if not passed */
CircleButton.counter = 0;
CircleButton.style = HrbCircleButtonStyle0;

export { CircleButton as hrb_circle_button };

